/* ============================================================
   MODA — Variant Styler v3
   Kalles block mode uses radio inputs + labels, not <select>
   This script styles them and adds the label display
   ============================================================ */
(function () {
  'use strict';

  function styleVariants() {
    /* Find all Kalles variant option groups */
    var groups = document.querySelectorAll(
      '.t4s-swatch-block, ' +
      '[class*="swatch-block"], ' +
      '.t4s-block-swatch, ' +
      '[class*="block-swatch"], ' +
      '.t4s-pr-form__option, ' +
      '[class*="variant-block"], ' +
      '[class*="option-block"]'
    );

    if (!groups.length) {
      /* Fallback: find radio inputs in product form */
      var radios = document.querySelectorAll(
        'form[action*="/cart/add"] input[type="radio"]'
      );
      if (radios.length) {
        console.log('[MODA] Found', radios.length, 'radio inputs');
        radios.forEach(function(r) {
          var label = document.querySelector('label[for="' + r.id + '"]');
          if (label) {
            label.classList.add('moda-vbtn');
            label.style.cssText = '';
          }
          r.addEventListener('change', function() {
            var name = this.name;
            document.querySelectorAll('input[type="radio"][name="' + name + '"]').forEach(function(rb) {
              var lb = document.querySelector('label[for="' + rb.id + '"]');
              if (lb) lb.classList.toggle('is-active', rb.checked);
            });
          });
          if (r.checked) {
            var lbl = document.querySelector('label[for="' + r.id + '"]');
            if (lbl) lbl.classList.add('is-active');
          }
        });
      }
      return;
    }

    groups.forEach(function(group) {
      group.classList.add('moda-vbtn__group');
      var labels = group.querySelectorAll('label');
      var inputs = group.querySelectorAll('input[type="radio"]');
      labels.forEach(function(label) {
        label.classList.add('moda-vbtn');
      });
      inputs.forEach(function(input) {
        if (input.checked) {
          var label = group.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.add('is-active');
        }
        input.addEventListener('change', function() {
          var groupEl = this.closest('.moda-vbtn__group, [class*="swatch-block"], [class*="block-swatch"]');
          if (!groupEl) return;
          groupEl.querySelectorAll('.moda-vbtn').forEach(function(l) {
            l.classList.remove('is-active');
          });
          var activeLabel = groupEl.querySelector('label[for="' + this.id + '"]');
          if (activeLabel) activeLabel.classList.add('is-active');
        });
      });
    });
  }

  /* Also run a DOM inspector to tell us what's actually there */
  function diagnose() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) { console.log('[MODA] No cart form found'); return; }
    console.log('[MODA] Form found. Children classes:');
    Array.from(form.children).slice(0,10).forEach(function(el) {
      console.log(' -', el.tagName, el.className.substring(0,80));
    });
    console.log('[MODA] All inputs in form:', form.querySelectorAll('input').length);
    console.log('[MODA] Radio inputs:', form.querySelectorAll('input[type=radio]').length);
    console.log('[MODA] Select elements:', form.querySelectorAll('select').length);
    console.log('[MODA] Labels:', form.querySelectorAll('label').length);
  }

  var attempts = 0;
  var poll = setInterval(function() {
    attempts++;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      diagnose();
      styleVariants();
      clearInterval(poll);
    }
    if (attempts >= 30) clearInterval(poll);
  }, 200);

  window.addEventListener('load', function() {
    setTimeout(function() { diagnose(); styleVariants(); }, 500);
  });
})();